/**
 * Add-to-bag SOURCE tracking for GA4 + Microsoft Clarity.
 * Added by Northern Collective — observational only: never calls preventDefault/
 * stopPropagation and returns the original fetch() promise untouched, so it can't
 * change how adding to bag behaves.
 *
 * Why: GA4's add_to_cart (sent by the Google & YouTube Shopify app) can't say WHERE
 * the add came from. This sends a companion event, add_to_cart_source, only after
 * Shopify confirms the add succeeded, with:
 *   add_source  pdp_main | quick_view | pdp_complete_the_set | cart_popup_complete_the_look |
 *               cart_drawer | cart_page | buy_now | other
 *   page_type   Shopify page type (product, collection, index, search, ...)
 *   item_id     shopify_ZZ_<product_id>_<variant_id>  (same format the app uses)
 *   item_name, item_variant, quantity, value, currency
 * Register add_source and page_type as event-scoped custom dimensions in GA4
 * (Admin > Custom definitions) before they show in reports.
 */
(function () {
  if (window.__ncAddSourceTracking) return;
  window.__ncAddSourceTracking = true;

  var GA4_ID = 'G-84HHCNTCEQ';
  var ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
  var lastContext = null; // { source, time }

  function pageType() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    if (m && m.pageType) return m.pageType;
    var p = window.location.pathname;
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/search') === 0) return 'search';
    if (p.indexOf('/cart') === 0) return 'cart';
    return p === '/' ? 'index' : 'other';
  }

  function classify(el) {
    if (!el || !el.closest) return 'other';
    if (el.closest('#Quick-view, quick-view')) return 'quick_view';
    if (el.closest('[data-matching-set], .product-matching-set')) return 'pdp_complete_the_set';
    if (el.closest('[data-cart-notification-complete-the-look], .cart-notification-complete-the-look')) {
      return 'cart_popup_complete_the_look';
    }
    if (el.closest('#CartDrawer, cart-drawer')) return 'cart_drawer';
    if (el.closest('cart-page')) return 'cart_page';
    if (pageType() === 'product') return 'pdp_main';
    return 'other';
  }

  function remember(source) {
    lastContext = { source: source, time: Date.now() };
  }

  // Context is captured at the moment of the click/submit, before the add request is sent.
  document.addEventListener(
    'click',
    function (event) {
      var buyNow = event.target.closest && event.target.closest('[data-buy-now-btn]');
      if (buyNow) remember('buy_now');
    },
    true
  );
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.action && ADD_URL.test(form.action)) remember(classify(form));
    },
    true
  );

  function send(source, item) {
    var gtagFn =
      typeof window.gtag === 'function'
        ? window.gtag
        : function () {
            (window.dataLayer = window.dataLayer || []).push(arguments);
          };
    var qty = item.quantity || 1;
    var unit = item.final_price != null ? item.final_price : item.price;
    var params = {
      send_to: GA4_ID,
      transport_type: 'beacon',
      add_source: source,
      page_type: pageType(),
      item_id: 'shopify_ZZ_' + item.product_id + '_' + item.variant_id,
      item_name: item.product_title || item.title,
      item_variant: item.variant_title || undefined,
      quantity: qty,
      value: unit != null ? Math.round(unit * qty) / 100 : undefined,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
    };
    gtagFn('event', 'add_to_cart_source', params);

    if (typeof window.clarity === 'function') {
      window.clarity('event', 'Add to bag: ' + source);
      window.clarity('set', 'addSource', source);
    }
  }

  function handleAdd(response) {
    try {
      if (!response || !response.ok) return; // failed add (e.g. out of stock) is not counted
      var ctx = lastContext && Date.now() - lastContext.time < 5000 ? lastContext : null;
      var source = ctx ? ctx.source : 'other';
      lastContext = null;
      response
        .clone()
        .json()
        .then(function (data) {
          var items = data && data.items ? data.items : data && data.variant_id ? [data] : [];
          items.forEach(function (item) {
            send(source, item);
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input) {
      var promise = originalFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && ADD_URL.test(url)) {
          promise.then(handleAdd, function () {});
        }
      } catch (e) {}
      return promise;
    };
  }
})();
